// eslint-disable-next-line
import React from 'react';
import { ModalDialog, IModalDialogProps } from '@cb/apricot-react';

export default function ModalDialogWrapper(props: IModalDialogProps) {
  return <ModalDialog {...props} />;
}
